export const ACCEPT = 'accept'
export const RESET = 'reset'
export const NAME = 'name'
export const EQUIPMENT_TYPE = 'installationTypes'
export const GEOZONE = 'geoZone'
export const PROJECT = 'project'
export const INTEGRATION = 'integrationIds'
export const REGION = 'region'
export const CITY = 'city'